import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MobileTooltipTriggerDirective } from '@shared/directives';
import { TextGamesSharedModule } from '@games/games-shared/text-games-shared.module';
import { SharedModule } from '@games/speed-reading/shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
// import { GameModule } from '@pages/games/game/game.module';
import { CollapsableOverlayPanelModule } from '@shared/components';
import { ButtonModule, FormFieldModule, TextsFilterComponent } from '@shared/components/games';
import { FontParametersModule } from '@shared/components/games/font-parameters';
import { TextsScreenPlayComponent } from './screens/texts-screen-play/texts-screen-play.component';
import { TextsControllerComponent } from './texts-controller/texts-controller.component';
import { TextsCorrectAnswerPreviewComponent } from './texts-preview/texts-answer-preview/texts-answer-preview.component';
import { TextsExamplePreviewComponent } from './texts-preview/texts-example-preview/texts-example-preview.component';
import { TextsParametersPreviewComponent } from './texts-preview/texts-parameters-preview/texts-parameters-preview.component';
import { TextsUserAnswerPreviewComponent } from './texts-preview/texts-user-answer-preview/texts-user-answer-preview.component';
import { PercentSliderComponent } from './texts-settings/percent-slider/percent-slider.component';
import { TextsHelpComponent } from './texts-settings/texts-help/texts-help.component';
import { TextsSettingsComponent } from './texts-settings/texts-settings.component';
import { BlindsManagerDirective } from './shared/blinds-manager.directive';
import { InputComponent } from '@new-core/components/inputs/input/input.component';

@NgModule({
  declarations: [
    TextsControllerComponent,
    TextsSettingsComponent,
    TextsCorrectAnswerPreviewComponent,
    TextsExamplePreviewComponent,
    TextsParametersPreviewComponent,
    TextsUserAnswerPreviewComponent,
    TextsScreenPlayComponent,
    TextsHelpComponent,
    BlindsManagerDirective,
  ],
  exports: [
    TextsControllerComponent,
    TextsSettingsComponent,
    TextsCorrectAnswerPreviewComponent,
    TextsExamplePreviewComponent,
    TextsParametersPreviewComponent,
    TextsUserAnswerPreviewComponent,
    NgSelectModule,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    ButtonModule,
    TextsFilterComponent,
    MatIconModule,
    MatButtonToggleModule,
    // GameModule,
    MatCardModule,
    CollapsableOverlayPanelModule,
    MatTooltipModule,
    MobileTooltipTriggerDirective,
    SharedModule,
    TextGamesSharedModule,
    FontParametersModule,
    PercentSliderComponent,
    FormFieldModule,
    InputComponent,
  ],
})
export class TextsModule {}
